import {useEffect, useState} from "react";
import {getCategories, listProducts, type Product} from "@corporatesclub/shared";
import {CategoryProductHub, type HubSection} from "./CategoryProductHub";
import {categorySlug, HUB_PAGE_SIZE} from "./categoryHubConstants";

const SORT_BEST_SELLERS = 1;

function categoryAllUrl(url: string): string {
  const base = url.split("?")[0];
  return `${base}?sort=${SORT_BEST_SELLERS}`;
}

async function loadSectionProducts(slug: string): Promise<Product[]> {
  const res = await listProducts({c: slug, sort: SORT_BEST_SELLERS, pageSize: HUB_PAGE_SIZE, page: 1});
  const items = [...res.items];
  if(items.length >= HUB_PAGE_SIZE) return items;
  const seen = new Set(items.map((p) => p.id));
  const rnd = await listProducts({c: slug, list: "best-sellers", pageSize: HUB_PAGE_SIZE * 2, page: 1});
  for(const p of rnd.items) {
    if(seen.has(p.id)) continue;
    items.push(p);
    seen.add(p.id);
    if(items.length >= HUB_PAGE_SIZE) break;
  }
  return items;
}

export function BestSellersView() {
  const [sections, setSections] = useState<HubSection[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getCategories()
      .then(async (r) => {
        const rows = await Promise.all(r.items.map(async (category) => {
          const slug = categorySlug(category.url);
          if(!slug) return null;
          const items = await loadSectionProducts(slug);
          if(!items.length) return null;
          return {category, items, allUrl: categoryAllUrl(category.url)};
        }));
        setSections(rows.filter((row): row is HubSection => row !== null));
      })
      .catch(() => setSections([]))
      .finally(() => setLoading(false));
  }, []);
  return (
    <CategoryProductHub
      variant="best"
      titleKey="Best Sellers"
      eyebrowKey="Popular"
      leadKey="Top sellers by category"
      sections={sections}
      loading={loading}
    />
  );
}
